export const parseQuery = (queryString) => {
  var query = {};
  if (queryString) {
    var pairs = (
      queryString[0] === '?' ? queryString.slice(1) : queryString
    ).split('&');

    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
  }
  return query;
};

export const setQueryParamIfAbsent = (url, key, value) => {
  try {
    // Parse only to check for an existing param. We append to the original
    // string rather than returning parsed.toString() so relative URLs stay
    // relative: new URL() resolves them against the current origin, which
    // would otherwise rewrite the host (matches appendQueryParam's behaviour).
    const parsed = new URL(url, window.location.origin);
    if (parsed.searchParams.has(key)) {
      return url;
    }
    // Insert the param before any fragment so the hash stays at the end of
    // the URL rather than swallowing the query string.
    const hashIndex = url.indexOf('#');
    const base = hashIndex === -1 ? url : url.slice(0, hashIndex);
    const fragment = hashIndex === -1 ? '' : url.slice(hashIndex);
    const separator = parsed.search ? '&' : '?';
    const param = `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`;
    return `${base}${separator}${param}${fragment}`;
  } catch (e) {
    return url;
  }
};

export const appendQueryParam = (url, obj) => {
  const str = [];
  let hasExistingParams = false;
  Object.keys(obj).forEach((v) => {
    if (obj[v]) {
      str.push(`${v}=${obj[v]}`);
    }
  });

  try {
    const urlTemp = new URL(url);
    hasExistingParams = !!urlTemp.search;
  } catch (e) {
    hasExistingParams = url.includes('?');
  }

  return `${url}${hasExistingParams ? '&' : '?'}${str.join('&')}`;
};
